import pluralize from 'pluralize'
import React, { useState } from 'react'
import Select from "react-select"
import { Upload, message } from 'antd'
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons'

import { usePet, useToggle } from '../../modules'

import Modal from "../resusable/modal"
import Ingredients from './ingredients'
import Confirm from '../resusable/confirm'

const Variant = ({ toggle, parent, onPerform, visible, type, loading, items, fetch, setString, onSave }) => {
    const [ingredients, setIngredients] = useState([])
    const [invRef, setInvRef] = useState(null)
    const [name, setName] = useState(null)
    const [price, setPrice] = useState(null)
    const [image, setImage] = useState(null)
    const [imageUrl, setImageUrl] = useState(null)
    const [imgLoading, setImgLoading] = useState(false)
    const [conversionRate, setConversionRate] = useState()
    const [_id, setId] = useState()

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            case 'price':
                setPrice(e.target.value)
                break

            case 'conversion-rate':
                setConversionRate(e.target.value)
                break

            default:
                break
        }
    }

    const [ingredientsModal, toggleIngredientsModal] = useToggle()

    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetch()
        }
    }

    const deleteIngredient = i => {
        let temp = [...ingredients]
        temp = temp.filter((_, index) => i !== index)

        setIngredients(temp)
    }

    const getBase64 = (img, callback) => {
        const reader = new FileReader()
        reader.addEventListener('load', () => callback(reader.result))
        reader.readAsDataURL(img)
    }

    const beforeUpload = file => {
        const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isImage) {
            message.warning('Please select an image file')
            return false
        }

        const sizeOK = file.size / 1024 / 1024 <= 1
        if (!sizeOK) {
            message.warning('Please select an image smaller than 1MB')
            return false
        }

        setImageUrl(null)
        setImage(file)
        setImgLoading(true)

        setTimeout(() => {
            setImageUrl(URL.createObjectURL(file))
            setImgLoading(false)
        }, 1000)

        return false
    }

    const handleChange = info => {
        if (info.file.status === 'uploading') {
            setImgLoading(true)
            return
        }

        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, url => {
                setImageUrl(url)
                setImgLoading(false)
            })
        }
    }

    const removeImage = () => {
        setImage(null)
        setImageUrl(null)
    }

    const addToList = () => {
        onSave({
            _id,
            name,
            price,
            conversionRate,
            ref: invRef,
            ingredients,
            image
        })
        toggle()
    }

    const onComplete = ({ data }, notif, ops) => {
        setId(data?._id)
        notif('Variant has been added', ops('success'))
        onPerform()
        setTimeout(addToList, 300)
    }

    const [, execute] = usePet('addVariantToSaleItem', {
        id: parent?._id, 
        name, 
        price, 
        ref: invRef ? invRef?.value : null, 
        ingredients, 
        conversionRate,
        image
    }, { notify: true, hasFile: true, callback: onComplete, manual: true, load: { msg: 'Adding variant...' } })

    const save = () => {
        if (parent) {
            Confirm({
                title: 'Add Variant?',
                message: 'Are you sure you want to add this variant?',
                onOk: execute,
                okText: 'Add Variant'
            })
        } else {
            addToList()
        }
    }

    return (
        <Modal
            h="h-auto"
            w="w-1/2 lg:w-1/3 xl:w-1/4"
            title="Add Variant"
            toggle={toggle}
            visible={visible}>
            <Ingredients
                ingredients={ingredients}
                onSave={setIngredients}
                visible={ingredientsModal}
                toggle={toggleIngredientsModal} />
            <div className="w-full bg-white">
                <div className="flex flex-wrap -mx-3 mb-6">
                    {
                        type?.value === 'Sale Item' &&
                        <>
                            <div className="w-full px-3 mb-3 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Inventory Item
                                </label>
                                <Select
                                    isLoading={loading}
                                    loadingMessage={string => `Searching for "${string?.inputValue}"`}
                                    onInputChange={search}
                                    value={invRef}
                                    onChange={ val => {
                                        setInvRef(val)
                                        setName(val.name)
                                    }}
                                    options={items.map(item => ({ label: item.name, value: item._id, ...item }))}
                                    placeholder="Search for inventory item" />
                                <p className="text-gray-500 text-xs italic">Which inventory item does it refer to?</p>
                            </div>
                            <div className="w-full px-3 mb-3 md:mb-0">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                                    Conversion Rate
                                </label>
                                <input
                                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                                    id="grid-conversion-rate"
                                    type="text"
                                    name="conversion-rate"
                                    value={conversionRate}
                                    onChange={modify}
                                    placeholder="1/2" />
                            </div>
                        </>
                    }
                    <div className="w-full px-3 mb-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Item Name
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-name"
                            type="text"
                            name="name"
                            value={name}
                            onChange={modify}
                            placeholder="Plain Fries" />
                    </div>
                    <div className="w-full px-3 mb-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Item Price
                        </label>
                        <input
                            className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                            id="grid-price"
                            name="price"
                            type="number"
                            value={price}
                            onChange={modify}
                            placeholder="XXXX" />
                    </div>
                    {
                        type?.value === 'Prepared Item' &&
                        <div className="w-full px-3 mb-3 md:mb-0">
                            <div className="font-bold mt-3">
                                <div className="flex justify-between items-center">
                                    <p className="font-bold my-3">Ingredients</p>
                                    <button onClick={toggleIngredientsModal} className="btn hisani-btn-green text-white my-3">
                                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                        </svg>
                                        <span className="hidden xs:block ml-2">Add</span>
                                    </button>
                                </div>
                                {
                                    ingredients?.length > 0 ?
                                        <table className="table-auto w-full mb-3">
                                            {/* Table header */}
                                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                <tr>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-left">No</div>
                                                    </th>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-left">Selected</div>
                                                    </th>
                                                    <th className="p-2">
                                                        <div className="font-semibold text-left">Quantity</div>
                                                    </th>
                                                    <th />
                                                </tr>
                                            </thead>
                                            {/* Table body */}
                                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                {
                                                    ingredients.map((ingredient, key) =>
                                                        <tr>
                                                            <td className="p-2 text-left">{key + 1}</td>
                                                            <td className="p-2 text-left">{ingredient.name}</td>
                                                            <td className="p-2 text-left">{ingredient.qty} {pluralize(ingredient.issuedIn, ingredient.qty)}</td>
                                                            <td onClick={() => deleteIngredient(key)} className="p-2 text-left text-red-500 cursor-pointer">X</td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    :
                                        <div className="text-center my-4">
                                            <h3>Please click above to add ingredients</h3>
                                        </div>
                                }
                            </div>
                        </div>
                    }
                    <div className="w-full px-3 mb-3 md:mb-0">
                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                            Upload Image
                        </label>
                        <Upload
                            name="avatar"
                            listType="picture-card"
                            className="avatar-uploader"
                            showUploadList={false}
                            action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                            beforeUpload={beforeUpload}
                            onChange={handleChange}>
                            {
                                imageUrl ?
                                    <img
                                        src={imageUrl}
                                        alt="avatar"
                                        style={{ width: '100%' }} />
                                    :
                                    <div>
                                        {imgLoading ? <LoadingOutlined /> : <PlusOutlined />}
                                        <div style={{ marginTop: 8 }}>{imgLoading ? 'Generating preview...' : 'Upload image'}</div>
                                    </div>
                            }
                        </Upload>
                        {
                            image && <p onClick={removeImage} className="text-red-500 cursor-pointer text-xs italic">X Remove</p>
                        }
                    </div>
                </div>
            </div>
            <div className="flex justify-end">
                <button onClick={save} type="submit" className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Save</button>
            </div>
        </Modal>
    )
}

export default Variant